import { useAsyncTask } from 'vue-concurrency'
import api from '@/api'
import { swalSuccess, swalConfirm, swalError } from '@/utils'

export function useRemind(bookHash: string) {
  const task = useAsyncTask(async () => {
    return api.book.remind({ cd: bookHash })
  }).drop()

  function remind() {
    swalConfirm.fire({ text: 'ご登録のメールアドレスへパスワードを再送します。' }).then(result => {
      if (result.isConfirmed) {
        task
          .perform()
          .then(() => {
            swalSuccess.fire({ text: 'ご登録のメールアドレスにパスワードを送信しました。ご確認ください。' })
          })
          .catch(err => {
            swalError.fire({ text: err })
          })
      }
    })
  }

  return { task, remind }
}
